module.exports = __webpack_public_path__ + "img/recognize.b8336f24.png";